import React, { Fragment } from 'react';

import Modal from '../../common/Modal';

function ForgotPasswordConfirmationModal({ visible, toggleModal, resend, emailResent }) {
  return (
    <Modal
      toggleModal={toggleModal}
      visible={visible}
      centered
    >
      <div className="text">
        <h2>
          An Email Has Been Sent
        </h2>
        <p>
          Please check your email and follow the instructions to continue your account recovery
        </p>
      </div>
      {emailResent
        ? (
          <div className="modal__response">
            Email has been resent.
          </div>
        ) : (
          <Fragment>
            <p className="modal__meta">
              Didn’t get an email?
            </p>
            <button
              type="button"
              className="button button--large"
              onClick={resend}
            >
              Resend Email
            </button>
          </Fragment>
        )
      }
    </Modal>
  );
}

export default ForgotPasswordConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/features/account/ForgotPasswordConfirmationModal.js